
export const packId = (id: number, period: 'past' | 'current') => (`${period}_${id}`)

export const unpackId = (packed: string): [string, number] => {
  const [period, idString] = packed.split('_')
  return [period, parseInt(idString, 10)]
}
